<div class="email-container">
    <!-- Header Section -->
    <header class="email-header">
        <div class="header-content">
            <div class="title-section">
                <h1 class="page-title">Email Templates</h1>
                <p class="page-subtitle">Manage your email templates</p>
            </div>
            <div class="header-controls">
                <div class="search-wrapper">
                    <mat-icon class="search-icon">search</mat-icon>
                    <input type="text" [formControl]="emailSearch" (input)="searchQuery.set(emailSearch.value || '')"
                        placeholder="Search templates..." class="search-input" aria-label="Search templates"
                        [disabled]="isLoading()" />
                    @if (emailSearch.value) {
                    <button class="clear-btn" (click)="clearSearch()" matTooltip="Clear search"
                        aria-label="Clear search">
                        <mat-icon>close</mat-icon>
                    </button>
                    }
                </div>
                <button class="btn-create" (click)="openEmailForm('new')">
                    <mat-icon>add</mat-icon>
                    <span class="btn-text">Create</span>
                </button>
            </div>
        </div>
    </header>

    <!-- Loading State -->
    @if (isLoading()) {
    <div class="loading-state">
        <div class="loading-spinner"></div>
        <p>Loading email templates...</p>
    </div>
    } @else {
    <!-- Main Content -->
    <main class="email-content">
        @if (emailDatas().length > 0) {
        <div class="table-container">
            <table class="email-table">
                <thead>
                    <tr>
                        <th class="col-name">Template Name</th>
                        <th class="col-published">Published</th>
                        <th class="col-subject">Subject</th>
                        <th class="col-updated">Updated At</th>
                        <th class="col-updated-by">Updated By</th>
                        <th class="col-actions">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    @for (email of emailDatas(); track trackByForEmailList($index, email)) {
                    <tr class="email-row" (click)="previewEmail(email, $event)">
                        <td class="col-name">
                            <span class="template-name">{{ email.templateName }}</span>
                        </td>
                        <td class="col-published">
                            @if (email.publishedSnapshot?.publishedAt) {
                            <span class="published-time" [matTooltip]="getPublicationTooltip(email)">
                                {{ email.publishedSnapshot!.publishedAt | dfnsFormatDistanceToNowStrict }} ago
                            </span>
                            } @else {
                            <span class="published-never">—</span>
                            }
                        </td>
                        <td class="col-subject">
                            <span class="subject-text">{{ email.subjectPart['en'] || '-' }}</span>
                        </td>
                        <td class="col-updated">
                            @if (email.updatedAt) {
                            <span class="date-text">{{ email.updatedAt | dfnsFormatDistanceToNowStrict }} ago</span>
                            } @else {
                            <span class="date-empty">-</span>
                            }
                        </td>
                        <td class="col-updated-by">
                            <span class="updated-by-text">{{ fbs.getUserNameFromId(email.updatedBy || email.createdBy)
                                || '-' }}</span>
                        </td>
                        <td class="col-actions">
                            <div class="action-buttons">
                                <button class="btn-action btn-edit" [routerLink]="['/email-editor', email.id]"
                                    (click)="$event.stopPropagation()" matTooltip="Edit">
                                    <mat-icon>edit</mat-icon>
                                </button>
                            </div>
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>

        <!-- Results Footer -->
        <footer class="results-footer">
            <div class="results-count">
                <mat-icon class="count-icon">folder_open</mat-icon>
                <span>Showing <strong>{{ emailDatas().length }}</strong> of <strong>{{ allEmailDatas().length
                        }}</strong> templates</span>
            </div>
        </footer>
        } @else {
        <!-- Empty State -->
        <div class="empty-state">
            <div class="empty-content">
                @if (emailSearch.value) {
                <div class="empty-icon-wrapper search">
                    <mat-icon class="empty-icon">search_off</mat-icon>
                </div>
                <h2 class="empty-title">No matching templates</h2>
                <p class="empty-description">We couldn't find any templates matching "<strong>{{ emailSearch.value
                        }}</strong>"</p>
                <button class="btn-empty" (click)="clearSearch()">
                    <mat-icon>clear</mat-icon>
                    <span>Clear Search</span>
                </button>
                } @else {
                <div class="empty-icon-wrapper">
                    <mat-icon class="empty-icon">email</mat-icon>
                </div>
                <h2 class="empty-title">No email templates</h2>
                <p class="empty-description">Create your first email template to get started</p>
                <button class="btn-empty" (click)="openEmailForm('new')">
                    <mat-icon>add</mat-icon>
                    <span>Create Template</span>
                </button>
                }
            </div>
        </div>
        }
    </main>
    }
</div>
